/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:43:46
 * @LastEditTime: 2023-03-01 18:37:09
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\index.js
 * 流向数据查询路由
 */
import rawDataRouter from './modules/rawDataRouter'
import rawDataStatisticRouter from './modules/rawDataStatisticRouter'
import fullFlowDataRouter from './modules/fullFlowDataRouter'
import flowSatementRouter from './modules/flowSatementRouter'
import accountClosingDataRouter from './modules/accountClosingDataRouter'

const flowDirectionDataQueryRouter = [].concat(
  rawDataRouter,
  rawDataStatisticRouter,
  fullFlowDataRouter,
  flowSatementRouter,
  accountClosingDataRouter,
)

export default flowDirectionDataQueryRouter
